import React from 'react';
import group_leader_crown from "../../../assets/images/group_leader_crown.png";
import * as Dialog from "@radix-ui/react-dialog";
import { Text } from "@radix-ui/themes";
interface Props {
  modalVisible: boolean;
  onNominate: () => void;
}
const CSGroupleader = ({ modalVisible, onNominate }: Props) => {
  return (
     <Dialog.Root open={modalVisible}>
      <Dialog.Portal>
        {/* Overlay */}
        <Dialog.Overlay
          className="fixed inset-0 bg-black/50 z-40 backdrop-blur-sm"
        />

        {/* Modal */}
        <Dialog.Content
          className="
          fixed z-50 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
          bg-[#24272C] shadow-xl rounded-xl p-6
          w-[90%] max-w-md flex flex-col items-center
        "
        >
          {/* Crown Circle */}
          <div
            className="
            bg-[#E9BE50] h-20 w-20 rounded-full border-[4px] border-white 
            shadow-md -mt-16 flex items-center justify-center
          "
          >
            <img src={group_leader_crown} className="h-10 w-10" />
          </div>

          {/* Title */}
          <Dialog.Title>
            <Text
              className="text-center text-white font-semibold text-base mt-4 px-2"
            >
              You have been selected as a Group Leader for your group.
            </Text>
          </Dialog.Title>

          {/* Action Button */}
          <button
            onClick={onNominate}
            className="
            bg-[#7056A1] text-white px-8 py-2 rounded-full font-medium 
            shadow mt-6 hover:bg-green-700 transition
          "
          >
            Ok
          </button>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default CSGroupleader;
